import React from 'react';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';

const Innovation = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow pt-32 pb-20 bg-dark-secondary">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-8">Innovation Leads to <span className="text-nvcti-orange">Improvement</span> Everywhere</h1>
                    <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">Discover how we foster innovation through our various labs, programs, and initiatives. State of art Lab & CoE.</p>
                    <div className="bg-dark-tertiary p-12 rounded-3xl shadow-2xl border border-white/5 max-w-3xl mx-auto backdrop-blur-md">
                        <div className="w-20 h-20 bg-nvcti-orange/10 rounded-full flex items-center justify-center mx-auto mb-6 text-4xl">💡</div>
                        <p className="text-gray-400 text-lg italic">Details of current innovations and prototypes will be listed here.</p>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Innovation;
